<div class="full-page w-100 d-md-flex d-block px-lg-0 bg-primary m-0">
  <div class="login-page-div d-flex flex-column justify-content-center align-items-center w-100 h-100">
    <div class="login-page-logo d-flex align-items-center">
      <img alt="" class="logo" src="assets/images/logo.png" draggable="false" />
    </div>
    <div class="container d-flex justify-content-center text-center">
      <div class="login-page-details d-flex flex-column justify-content-center align-items-center">
        <div class="panel-text login-text font-size-14 d-flex align-items-center text-white">
          {{ 'login.page.description' | translate }}
        </div>
        <fgb-tm-user-login></fgb-tm-user-login>

        <ng-container *ngIf="errorCode$ | async as errorCode">
          <div
            class="login-text-info text-white text-center my-5 mx-3 font-size-14"
            [innerHTML]="errorCode | translate | markdownTranslate"
          ></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
